import { all, takeEvery, put, select } from 'redux-saga/effects';
import actions from './actions';
import fake from './fake';
import fakeinitdata from './config';
import siteConfig from '@iso/config/site.config';
import { notification } from '@iso/components';
import invoiceActions from '../invoice/actions';
const { INVOICE_USER } = invoiceActions;
const gaxios = require('gaxios');
gaxios.instance.defaults = { baseURL: siteConfig.siteUrl.API_URL };

const headers = () => ({
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
  token: localStorage.getItem('id_token'),
});

export function* changedCard() {
  yield takeEvery(actions.CHANGE_CARDS, function*() {});
}

export function* initData() {
  let fakeData = fakeinitdata;
  if (fakeinitdata.productQuantity.length === 0) {
    fakeData = fake;
  }
  yield put({
    type: actions.INIT_DATA,
    payload: fakeData,
  });
}

export function* updateData({ products, productQuantity }) {
  localStorage.setItem('cartProductQuantity', JSON.stringify(productQuantity));
  localStorage.setItem('cartProducts', JSON.stringify(products));
  yield put({
    type: actions.UPDATE_DATA,
    products,
    productQuantity,
  });
}
 
export function* getVentas(action) {
  const query = action.query ? `?${action.query}` : '';
  let ULRDestino = "api/ventas/"+query;
  const res = yield gaxios.request({
    url: ULRDestino,
    headers: headers(),
  });

  if( res.data.success ) {
    yield put({
      type: actions.FORMATEAR_VENTAS,
      payload: res.data.ventas,
    });
    if (res.data.paginationInfo){
      yield put({
        type: actions.SET_PAGINATION_INFO_VENTAS,
        payload: res.data.paginationInfo,
      });
    }

  }else{
    notification('error', res.data.msg );
  }
}

export function* setVenta(action) {
  const {Auth} = yield select();
  action.venta.vendedor = Auth.id_token;
  let ULRDestino = "api/ventas";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: { data: [action.venta] },
    method: metodo,
    headers: headers(),
  });
  if( res.data.success ){
    yield put({type: actions.RESET_VENTA, success: res.data.success});
    yield put({type: actions.GET_VENTAS, query: "producida=false&enProduccion=false&aprobado=true"});
    notification('success', res.data.msg );
  }else{
    console.log(res.data)
    yield put({type: actions.RESET_VENTA, success: res.data.success, error: res.data.msg});
    notification('error', res.data.msg );
  }
}

export function* editVenta(action) {
  const {Auth} = yield select();
  action.data.vendedor= Auth.id_token;
  delete action.data._id;
  let ULRDestino = "api/ventas/"+action.id;
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.data,
    method: metodo,
    headers: headers(),
  });
  if( res.data.success ){
    yield put({type: actions.UPDATE_SPECIFIC_VENTA, doc: {...res.data.doc, actualizar: action.data.actualizar}});
    notification('success', res.data.msg );
  }else{
    notification('error', res.data.msg );
  }
}

export function* deleteVenta(action) {
  let ULRDestino = "api/ventas/"+action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    headers: headers(),
  });
  if( res.data.success ){
    yield put({type: actions.DELETE_SPECIFIC_VENTA, id: action.id});
    notification('success', res.data.msg );
  }else{
    notification('error', res.data.msg );
  }
}

export function* getVentasUser(action) {
  const query = action.query ? `?${action.query}` : ""
  let ULRDestino = "api/ventas/user/"+action.data.id+query;
  const res = yield gaxios.request({
    url: ULRDestino,
    headers: headers(),
  });
  if( res.data.success ){
    yield put({
      type: INVOICE_USER,
      payload: res.data.ventas,
    });
  }else{
    notification('error', res.data.msg );
  }
}

export function* descargarVentas(action) {

  const res = yield gaxios.request({
    url: 'api/download/ventas',
    data: { data: action.idsVentas },
    method: 'POST',
    headers: headers(),
  });
  console.log(res)
}


export default function*() {
  yield all([
    takeEvery(actions.INIT_DATA_SAGA, initData),
    takeEvery(actions.UPDATE_DATA_SAGA, updateData),
    takeEvery(actions.SET_VENTA, setVenta),
    takeEvery(actions.GET_VENTAS_USER, getVentasUser),
    takeEvery(actions.GET_VENTAS, getVentas),
    takeEvery(actions.DELETE_VENTA, deleteVenta),
    takeEvery(actions.EDIT_VENTA, editVenta),
    takeEvery(actions.DESCARGAR_VENTAS, descargarVentas),
  ]);
}
